import { Component, Inject, OnInit } from '@angular/core';
import { Pipeline } from '@vendasta/sales-common';
import { combineLatest, Observable } from 'rxjs';
import { OpportunityService } from '../../../../../../opportunity.service';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { Opportunity, StageInterface } from '@vendasta/sales-opportunities';
import { SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN, SalesUIOpportunityDetailsConfig } from '../../../../../../tokens';

@Component({
  selector: 'sales-ui-pipeline-selector',
  templateUrl: './pipeline-selector.component.html',
  standalone: false,
})
export class PipelineSelectorComponent implements OnInit {
  protected opportunity$: Observable<Opportunity>;
  protected selectedPipeline$: Observable<Pipeline>;
  protected selectedStage$: Observable<StageInterface>;
  protected userPipelines$: Observable<Pipeline[]>;

  constructor(
    @Inject(SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN) private readonly config: SalesUIOpportunityDetailsConfig,
    private readonly opportunityUpdates: OpportunityService,
  ) {}

  ngOnInit(): void {
    this.userPipelines$ = this.config.pipelines$;
    this.opportunity$ = this.opportunityUpdates.currentOpportunity$;
    this.selectedPipeline$ = combineLatest([this.opportunity$, this.userPipelines$]).pipe(
      distinctUntilChanged(),
      map(([opp, pipelines]) => {
        const oppPipeline = pipelines.find((p) => p.id === opp.pipelineId);
        if (pipelines.length >= 1 && !oppPipeline) {
          return pipelines[0];
        } else {
          return oppPipeline;
        }
      }),
    );

    this.selectedStage$ = combineLatest([this.selectedPipeline$, this.opportunity$]).pipe(
      distinctUntilChanged(),
      map(([pipeline, opp]) => {
        return pipeline.findStage(opp.probability);
      }),
    );
  }

  protected pipelineSelectionChange(pipeline: Pipeline, opp: Opportunity): void {
    this.opportunityUpdates.updatePipelineId(opp, pipeline.id, opp.probability);
  }

  protected stageSelectionChange(stage: StageInterface, opp: Opportunity): void {
    this.opportunityUpdates.updateProbability(opp, stage.probability);
  }

  protected readonly Boolean = Boolean;
}
